export default __webpack_public_path__ + "static/media/cg-register-img.a0df0023.svg";